const appThemes = [
	{
		path: '/themes/app-themes/list',
		name: 'app-themes-list',
		component: () => import('@/views/themes/app-themes/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/themes/projects-variables/list',
		name: 'projects-variables-list',
		component: () => import('@/views/themes/projects-variables/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
]

export default appThemes
